import { SnackbarMessage, OptionsObject } from 'notistack';
import { Notification } from 'store/notification';
import { AxiosError } from 'axios';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

interface EnqueueSnackbarAction {
  type: typeof ENQUEUE_SNACKBAR;
  key: string | number;
  notification: Notification;
}

interface CloseSnackbarAction {
  type: typeof CLOSE_SNACKBAR;
  key: string | number;
  dismissAll: boolean;
}

interface RemoveSnackbarAction {
  type: typeof REMOVE_SNACKBAR;
  key: string | number;
}

export type NotificationActions =
  | EnqueueSnackbarAction
  | CloseSnackbarAction
  | RemoveSnackbarAction;

export const enqueueSnackbar = (
  message: SnackbarMessage,
  options?: OptionsObject,
) => {
  const key = options?.key;
  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      message,
      options,
      key: key || new Date().getTime() + Math.random(),
    },
  };
};

export const enqueueError = (message: string) =>
  enqueueSnackbar(message, { variant: 'error' });

export const enqueueErrorResponse = (error: AxiosError) => {
  const msg = error?.response?.data?.errorMessage;
  if (msg) {
    return enqueueError(msg);
  } else {
    return enqueueError(error.message);
  }
};

export const closeSnackbar = (key?: string | number) => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeSnackbar = (key: string | number) => ({
  type: REMOVE_SNACKBAR,
  key,
});

export const notificationActions = {
  enqueueSnackbar,
  enqueueError,
  enqueueErrorResponse,
  closeSnackbar,
  removeSnackbar,
};
